<template>
  <el-row class="container">
    <!--头部-->
    <el-col :span="24" class="topbar-wrap">   
      <div class="topbar-title">
        <span style="font-size: 24px;color: #fff;">DDS数据分发与缴存系统</span>
        <div class="openClose" @click="collapse">
          <i v-if="!collapsed" class="el-icon-menu"></i>
          <i v-else class="el-icon-s-grid"></i>
        </div>
      </div>

      <!-- 用户设置临时注释掉，后续增加用户登陆后放开 -->
      <div class="topbar-account topbar-btn">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link userinfo-inner"><i class="iconfont icon-user"></i> {{nickname}}  <i
            class="iconfont icon-down"></i></span>
          <el-dropdown-menu slot="dropdown">
            <!--
            <el-dropdown-item>
              <div @click="jumpTo('/user/changepwd')"><span style="color: #555;font-size: 14px;">修改密码</span></div>
            </el-dropdown-item>
            -->
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

    </el-col>

    <!--中间-->
    <el-col :span="24" class="main">
      <!--左侧导航-->
      <aside :class="{showSidebar:!collapsed}">
        <!--导航菜单-->
        <el-menu :default-active="$route.path" :collapse="collapsed" @select="handleSelect" @open="handleOpen" :default-openeds="openeds"
            background-color="#333744"
            text-color="#fff"
            active-text-color="#ffd04b">
          <template v-for="(item,index) in $store.getters.routers" v-if="item.menuShow">

            <el-submenu v-if="!item.leaf" :index="index+''">
              <template slot="title"><i :class="item.iconCls"></i><span slot="title">{{item.name}}</span></template>
              <el-menu-item v-for="term in item.children" :key="term.path" :index="term.path" v-if="term.menuShow"
                            :class="$route.path==term.path?'is-active':''">
                <i :class="term.iconCls"></i><span slot="title">{{term.name}}</span>
              </el-menu-item>
            </el-submenu>
            
            <el-menu-item v-else-if="item.leaf&&item.children&&item.children.length" :index="item.children[0].path"
                          :class="$route.path==item.children[0].path?'is-active':''">
              <i :class="item.iconCls"></i><span slot="title">{{item.children[0].name}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </aside>

      <!--右侧内容区-->
      <section class="content-container" style="overflow-x:hidden">
        <breadcrumb></breadcrumb>
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="content-wrapper">
            <transition name="fade-transform" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>

  </el-row>
</template>

<script>
  import {bus} from '../bus.js'
  import API_ADMIN from "../api/api_user";
  import util from "../common/util";
  import Breadcrumb from '@/components/Breadcrumb'

  export default {
    name: 'home',
    components: {
      Breadcrumb,
    },
    created(){
      bus.$on('setNickName', (text) => {
        this.nickname = text;
      })

      bus.$on('goto', (url) => {
        if (url === "/login") {
          //localStorage.removeItem('access-user');
          sessionStorage.removeItem('userName');
          sessionStorage.removeItem('accessToken');
          sessionStorage.removeItem('refreshToken');
          sessionStorage.removeItem('expiresIn');
        }
        this.$router.push(url);
      })
    },
    data () {
      return {
        defaultActiveIndex: "1",
        nickname: '',
        collapsed: false,
        openeds: ['2', '3', '4', '5'],
      }
    },
    methods: {
      handleSelect(index){
        this.defaultActiveIndex = index;
        this.$router.push(index)
        //console.log("..........index:" + index);
      },
      handleOpen(index){
        console.log("..........index:" + index);
      },
      //折叠导航栏
      collapse: function () {
        this.collapsed = !this.collapsed;
      },
      jumpTo(url){
        this.defaultActiveIndex = url;
        this.$router.push(url); //用go刷新
      },
      logout(){
        let that = this;
        this.$confirm('确认退出吗?', '提示', {
          confirmButtonClass: 'el-button--warning'
        }).then(() => {
          //确认
          that.loading = true;
          API_ADMIN.logout().then(function (result) {
            that.loading = false;
            //localStorage.removeItem('access-user');            
            sessionStorage.removeItem('userName');
            sessionStorage.removeItem('accessToken');
            sessionStorage.removeItem('refreshToken');
            sessionStorage.removeItem('expiresIn');
            that.$router.go('/login'); //用go刷新
          }, function (err) {
            that.loading = false;
            that.$message.error({showClose: true, message: err.toString(), duration: 2000});
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
          });
        }).catch(() => {});
      },
    },
    mounted() {
      this.nickname = sessionStorage.getItem("userName");
      console.log("store.getters.routers:" + this.$store.getters.routers);
    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
     /deep/.el-submenu .el-menu{
      background-color: #333744!important;
    }
    /deep/.el-menu{
      background-color: #333744!important;
    }
  .container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    .openClose{
      font-size: 20px;
      color: #fff;
      display: inline-block;
      margin-left: 6px;
      cursor: pointer;
    }
    .topbar-wrap {
      background: #333744;
      padding: 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 20px;
      .topbar-btn {
        color: #fff;
        .icon-user{
          font-size: 18px;
        }
      }
      /*.topbar-btn:hover {*/
      /*background-color: #4A5064;*/
      /*}*/
      .topbar-logo {
        float: left;
        width: 59px;
        line-height: 26px;
      }
      .topbar-logos {
        float: left;
        width: 120px;
        line-height: 26px;
      }
      .topbar-logo img, .topbar-logos img {
        height: 40px;
        margin-top: 5px;
        margin-left: 2px;
      }
      .topbar-title {
        float: left;
        text-align: left;
        width: 400px;
        padding-left: 10px;
      }
      .topbar-account {
        float: right;
        padding-right: 12px;
      }
      .userinfo-inner {
        cursor: pointer;
        color: #fff;
        padding-left: 10px;
        font-size: 16px;
      }
    }
    .main {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      position: absolute;
      top: 63px;
      bottom: 0px;
      overflow: hidden;
    }
    aside {
      min-width: 50px;
      background: #333744;
      &::-webkit-scrollbar {
        display: none;
      }

      &.showSidebar {
        overflow-x: hidden;
        overflow-y: auto;
      }

      .el-menu {
        height: 100%; /*写给不支持calc()的浏览器*/
        height: -moz-calc(100% - 80px);
        height: -webkit-calc(100% - 80px);
        height: calc(100% - 80px);
        border-radius: 0px;
        background-color: #333744;
        border-right: 0px;
      }

      .el-submenu .el-menu-item {
        min-width: 60px;
      }
      .el-menu {
        width: 180px;
      }
      .el-menu--collapse {
        width: 60px;
      }

      .el-menu .el-menu-item, .el-submenu .el-submenu__title {
        height: 46px;
        line-height: 46px;
      }

      .el-menu-item:hover, .el-submenu .el-menu-item:hover, .el-submenu__title:hover {
        background-color: #7ed2df;
      }
    }

    .menu-toggle {
      background: #4A5064;
      text-align: center;
      color: white;
      height: 26px;
      line-height: 30px;
    }

    .content-container {
      background: #fff;
      flex: 1;
      overflow-y: auto;
      padding-bottom: 1px;

      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
      .grid-content{
        padding: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue